import { FC } from "react";
import parse from "html-react-parser";

interface Props {
  data: { markup?: string };
}

const HTML: FC<Props> = ({ data }) => {
  if (!data.markup) {
    return null;
  }

  return <div>{parse(data.markup)}</div>;
};

export default HTML;
